'use client';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
// import Button from "@mui/material/Button";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import * as _ from 'lodash';
import Cookies from 'js-cookie';
import {
  MagnifyingGlassIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowsUpDownIcon,
  ArrowTopRightOnSquareIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DeleteIcon,
} from '@heroicons/react/24/outline';
// import mqtt from 'mqtt';
import { useUserContext } from '../contexts/UserContext';
import { set } from 'date-fns';



const RsiAbove70Component = props => {
  const {
    user
  } = useUserContext();
  const [rsiAbove70Data, setRsiAbove70Data] = useState([]);
 
  const [client, setClient] = useState(null);
  // const mqttClientRef = useRef(null); // holds the MQTT client instance
  // const mqttListenerAttached = useRef(false); // ensures only one message handler is attached
  const wsRefBinance = useRef(null);
  const [lastUpdated, setLastUpdated] = useState(new Date().valueOf());
 const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    async function fetchData() {
      if (user.userType == "ADMIN") {
        // await _connectMQTT(props);
        await getRsiAbove70Data();

      }
    }
    fetchData();
  }, []);

    //i want to call getMeanTheoryData, every hour's 02 minute
    // like 4:02, 5:02, 6:02 etc, fix the code
    useEffect(() => {
      const interval = setInterval(() => {
        const now = new Date();
        if (now.getMinutes() === 2) {
          getRsiAbove70Data();
        }
      }, 60000); // 60000 ms = 1 minute
      return () => clearInterval(interval);
    }, []);



  const getRsiAbove70Data = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/dashboard/getRsiAbove70Data`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        setRsiAbove70Data([]);
        return;
      }


      const result = await response.json();

      if (result.success) {
         setRsiAbove70Data(result.data);
        setLastUpdated(new Date().valueOf());

      } else {
        console.error('Invalid response format:', result.message || 'Unknown error');
      }
    } catch (e) {
      console.error('Error fetching open trades:', e);
    }
  };



  // async function handleDelete(uuid) {
  //   // console.log("Deleting PreWatcher:", uuid)
  //   //remove preWatcher from preWatchers state
  //   // setPreWatchers(prevPreWatchers => prevPreWatchers.filter(preWatcher => preWatcher.uuid !== uuid));

  //   const gsccookie = Cookies.get('gsccookie') || null;
  //   console.log("Deleting PreWatcher:", uuid, gsccookie)

  //   client.publish("DELETE_PREWATCHER", JSON.stringify({ token: gsccookie, uuid }), err => {

  //   });
  // }



  // Memoize preWatchers with current prices for rendering

  return rsiAbove70Data ? (
    <div style={{ borderRadius: 8, width: 'auto' }}>
      <h1 className="text-xs" style={{ margin: 0, paddingTop: 1, color: 'gray', marginBottom: 3 }}>
        Last Updated: {new Date(lastUpdated).toLocaleDateString()} ,{' '}
        {new Date(lastUpdated).toLocaleTimeString()}
      </h1>





      <h1 className="text-sm" style={{ margin: 0, paddingTop: 1, color: '#fff', marginBottom: 3 }}>
        Count: {rsiAbove70Data.length}
      </h1>


      {rsiAbove70Data.sort((a, b) => b.creationDate - a.creationDate).map((item, index) => (

        <div key={item.symbol}  style={{ padding: 5, margin: 5, borderRadius: 10 }}>


          <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>

            
            <div style={{ alignItems: 'center', display: 'flex', gap: 5 }}>
              <h4 style={{ fontWeight: 'bolder', marginLeft: 3, color: "white" }}>{index + 1}. {item.symbol}</h4>
              <h5 style={{ margin: 0, paddingTop: 1, color: 'white', fontSize : 12 }}>{new Date(item.creationDate).toLocaleString()}</h5>
             <h4 style={{ fontWeight: 'bolder', marginLeft: 3, color: "green" }}>{item.candleWithRSIAbove70
.close}</h4>-<h4 style={{ fontWeight: 'bolder', marginLeft: 3, color: "red" }}>{item.candleWithLowestRSI
.close}</h4>
              <h5 style={{ margin: 0, paddingTop: 1, color: 'white', fontSize : 12, marginLeft : 5 }}>({((item.candleWithRSIAbove70.close - item.candleWithLowestRSI.close) * 100 / item.candleWithRSIAbove70.close).toFixed(2)}%)</h5>
              <button
                style={{
                  backgroundColor: '#7e8082ff',
                  fontSize: 12,
                  borderRadius: 5,
                  padding: 3,
                  alignItems: 'center', display: 'flex'
                }}
                onClick={() => {
                  window.open(
                    'https://www.coinglass.com/tv/Binance_' + item.symbol,
                    '_blank'
                  )

                }}
              >
                <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>CoinGlass</h4>
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
                >
                  {/* Dark background circle matching trading terminal themes */}
                  <circle cx="16" cy="16" r="16" fill="#1E222D" />

                  {/* Upward diagonal arrow symbolizing market breakouts and data shifts */}
                  <path
                    d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                    stroke="#ffffff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  {/* Subtle outer border for depth */}
                  <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                </svg>

              </button>
              <button
                style={{
                  backgroundColor: '#7e8082ff',
                  fontSize: 12,
                  borderRadius: 5,
                  padding: 3,
                  alignItems: 'center', display: 'flex'
                }}
                onClick={() => {
                  window.open(
                    'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + item.symbol,
                    '_blank'
                  )

                }}
              >
                <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Trading View</h4>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
                >
                  {/* Standard Terminal Background */}
                  <circle cx="16" cy="16" r="16" fill="#1E222D" />

                  {/* TradingView 'Chart' Bars - Representing Technical Analysis */}
                  <rect x="9" y="15" width="3" height="7" rx="1" fill="#ffffff" />
                  <rect x="14.5" y="10" width="3" height="12" rx="1" fill="#ffffff" />
                  <rect x="20" y="13" width="3" height="9" rx="1" fill="#ffffff" />

                  {/* Border for UI consistency */}
                  <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                </svg>
              </button>
              {/* <button
                style={{
                  backgroundColor: '#298f09ff',
                  fontSize: 12,
                  borderRadius: 5,
                  padding: 3,
                  alignItems: 'center', display: 'flex',

                }}
                onClick={async () => {
                  await getMeanTheoryDataForSymbol(item.symbol);
                }}
              >
                <h5 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Show more...</h5>


              </button> */}
              {/* show the maxCreationDate of the symbol in format "Last Updated: 8/30/2024, 4:02:15 PM" just beside the symbol name in smaller font and grey color */}
            
            </div>

            {/* The below button should be on the extreme right of the table row and should have a red background with a white cross icon in the center */}

            <button
              style={{
                background: 'red',
                border: 'none',
                borderRadius: 5,
                color: '#fff',
                cursor: 'pointer',
                marginLeft: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 20,
                height: 20,
                padding: 0,
              }}
              title="Delete"
              onClick={() => {
                alert(`Delete ${item.symbol}`);
              }}
            >
              {/* the cross is not exactly in the middle of red box */}
              {/* can you fix the below svg so that the cross is exactly in the middle of red box */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                fill="none"
                viewBox="0 0 12 12"
                stroke="white"
                style={{ display: 'block', margin: 'auto', alignItems: 'center', justifyContent: 'center' }}
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 3l8 8M11 3l-8 8" />
              </svg>
            </button>
          </div>

        </div>
      ))}

    </div>

  ) : null;
};


export default RsiAbove70Component;
